import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/product_hierarchies', { params });
  },
  detail(id) {
    return axios.get(`/v1/product_hierarchies/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/product_hierarchies/${id}`, params);
  },
  create(data) {
    return axios.post('/v1/product_hierarchies', data);
  },
  getStage(params = {}) {
    return axios.get('/v1/stages', { params });
  },
  delete(id) {
    return axios.delete(`/v1/product_hierarchies/${id}`);
  }
};
